import { registerCardTemplate } from "../../../common/common";
import { lazyTemplate } from "../../lazyTemplate";
import { generateIconProp } from "../../../common/icon-selector/IconEditor";

registerCardTemplate({
    id: 'youtube-card',
    name: "YouTube Card",
    description: 'A card that can play YouTube video',
    template: lazyTemplate(() => import(/* webpackChunkName: "tpl-youtube-card" */ "./YoutubeCardTemplate")),
    icon: generateIconProp('youtube'),
    complexity: 'easy',
    layout: {
        w: 10,
        h: 9
    }
});
